angular.module('ngWig')
    .config(['ngWigToolbarProvider', function (ngWigToolbarProvider) {
       ngWigToolbarProvider.addCustomButton('color', 'nw-color-button');
    }])
    .component('nwColorButton', {
        bindings: {
            content: '=',
            execCommand: '=',
            editMode: '=',
            disabled: '='
        },
        template: `<input type="color" ng-disabled="$ctrl.editMode || $ctrl.disabled" ng-model="color" />`,
        controller: function($scope) {
            var main = this;

            $scope.$watch('color', function() {
                if($scope.color) {
                    console.log($scope.color);
                    main.execCommand('foreColor', $scope.color);
                }
            });
        }
    });
